module.exports = __webpack_public_path__ + "img/header-engagementRingsCharacter.6f448d1.webp";